import { useState, useEffect, useCallback, useRef } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const projects = [
  {
    id: 1,
    title: 'Full Color Worship Banner',
    client: 'UHOPFAP-Norfolk, VA',
    category: 'Branding',
    description: 'Complete brand identity refresh including logo, color palette, and marketing materials for a growing church community.',
    challenge: 'Modernize the brand while maintaining spiritual authenticity and connection with diverse congregation.',
    solution: 'Created a warm, welcoming brand identity with contemporary design elements that honor tradition.',
    results: '40% increase in community engagement, improved recognition across all touchpoints.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/5c6565f8-a43f-4401-a519-dff814bd25f0_NORFOLK-PWS-2.jpg?v=05cd45654a95daabfcbcaa40ef300b68'
  },
  {
    id: 2,
    title: 'Banner Sign',
    client: "BOSCOV'S DEPARTMENT STORE- DEPTFORD, NJ",
    category: 'Signage',
    description: 'Eye-catching storefront signage and window graphics that transformed foot traffic and brand visibility.',
    challenge: 'Stand out in a competitive downtown area with limited storefront space.',
    solution: 'Designed bold, illuminated signage with complementary window graphics and outdoor seating branding.',
    results: '60% increase in walk-in customers, became a neighborhood landmark.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/76c22a01-2af4-4d87-ae74-f7dc13f22676_SIGNS-6.jpg?v=6f90514f98d40e7157764e9e1c2023b5'
  },
  {
    id: 3,
    title: 'Building Sign/ Banner Sign',
    client: 'Bailey Village Luxury Apartments',
    category: 'Branding',
    description: 'Comprehensive brand identity for a tech startup including logo, business cards, and digital assets.',
    challenge: 'Create a modern, trustworthy brand for a new player in the competitive tech industry.',
    solution: 'Developed a sleek, minimalist identity with bold typography and a distinctive color palette.',
    results: 'Successfully launched with strong brand recognition, secured major client contracts.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/f24ded24-c011-4358-a497-7be669b18ccb_SIGNS-1.jpg?v=d05f418bb99309f13d3fe2ccbfcaa10d'
  },
  {
    id: 4,
    title: "Convention Banner 3'x14''",
    client: 'UHOPFAP NATIONAL CONVENTION-DC',
    category: 'Print',
    description: 'Beautifully designed annual report showcasing impact stories and financial transparency.',
    challenge: 'Present complex data in an engaging, accessible format that inspires continued support.',
    solution: 'Created an elegant publication with infographics, photography, and compelling storytelling.',
    results: '25% increase in donor engagement, award-winning design recognition.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/c5c45e83-ffbd-4212-9f4f-039237102dfd_ANNOUNCE-25.jpg?v=142e39ba89ee7051d94013d9ef5c0b5b'
  },
  {
    id: 5,
    title: 'Parking Signage',
    client: 'UHOPFAP MIAMI',
    category: 'Signage',
    description: 'Professional parking signage design with clear directional elements and modern aesthetic for urban parking facility.',
    challenge: 'Create clear, visible signage that guides drivers efficiently while maintaining a professional city aesthetic.',
    solution: 'Designed bold, high-contrast signage with intuitive directional arrows and clear typography for maximum visibility.',
    results: 'Improved traffic flow and reduced confusion for parkers, received positive feedback from city officials.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/173c7437-7706-4acf-ad3f-8d452e204a09_MIAMI-PARKING-1.jpg?v=71d7cedf36af1fba8b15c17c36ab2ce0'
  },
  {
    id: 6,
    title: 'Cafe Sign',
    client: 'UHOP CAFE- BUFFALO-NY',
    category: 'Marketing',
    description: 'Luxury real estate marketing materials including property brochures, signage, and digital assets.',
    challenge: 'Convey luxury and professionalism while showcasing diverse property portfolio.',
    solution: 'Created a sophisticated brand system with premium materials and stunning property photography.',
    results: '45% faster property sales, elevated brand positioning in luxury market.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/6863783e-41ee-4e76-84fd-73422c43bf6b_BUFF-LOVE.jpg?v=5b6bea36c753a7695c0a76716d992dbd'
  },
  {
    id: 7,
    title: 'Screenprinted Sweatshirts',
    client: 'UHOP CAFE- BUFFALO-NY',
    category: 'Branding',
    description: 'Complete brand identity for new fitness center including logo, signage, and membership materials.',
    challenge: 'Create an energetic, motivating brand that appeals to all fitness levels.',
    solution: 'Developed a bold, dynamic identity with vibrant colors and inspiring messaging.',
    results: 'Successful launch with 500+ memberships in first three months.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/f91f0a9d-52d7-41c4-b21d-437a583a1299_f89bf44f-73b3-46dd-8980-14cf54f967751.jpg?v=e885d9a7a503dfa0fed2ac4e744497e5'
  },
  {
    id: 8,
    title: 'Green Earth Nonprofit Campaign',
    client: 'Green Earth Initiative',
    category: 'Marketing',
    description: 'Multi-channel marketing campaign for environmental nonprofit including print, digital, and outdoor advertising.',
    challenge: 'Raise awareness and drive donations for environmental conservation efforts.',
    solution: 'Created compelling campaign with powerful imagery and clear call-to-action across all channels.',
    results: '200% increase in donations, significant growth in volunteer participation.',
    image: 'https://public.readdy.ai/ai/img_res/4e5f5b51a432eb32d91cc46f61d73429.jpg nonprofit marketing campaign materials with nature photography and inspiring messaging, green conservation campaign posters and brochures, impactful nonprofit advertising design&width=1200&height=800&seq=portfolio14&orientation=landscape'
  },
  {
    id: 9,
    title: 'Interior Wall Sign',
    client: 'KDC PRODUCE DISTRIBUTION- VINELAND, NJ',
    category: 'Print',
    description: 'Custom packaging design for artisan bakery products including bread bags, boxes, and labels.',
    challenge: 'Create packaging that reflects handcrafted quality while being practical for daily use.',
    solution: 'Designed rustic yet refined packaging with hand-drawn illustrations and premium materials.',
    results: 'Products now featured in premium retailers, 35% increase in wholesale orders.',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/5f29de87-84e0-4521-95fe-6793bd1eb5a1_SIGNS-5.jpg?v=877043d2138d8eef10f2c678e1f62fec'
  },
  {
    id: 10,
    title: 'Event Poster',
    client: 'GOSPEL MUSIC FEST CHARLOTTE, NC',
    category: 'Print',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/39244175-120a-4f49-972f-5dc0c7aa0bd6_Together-we-request-the-company-of-your-presence-to-celebrate-the-marriage-of-12-x-18-in-3.svg?v=6c13f7e11229198aac7eead2b4251aca'
  },
  {
    id: 11,
    title: 'Banner Sign',
    client: 'Savannah, GA- District Banner',
    category: 'Branding',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/939b4551-63cd-4211-9484-e26b6d1d79a9_SIGNS-7.svg?v=9fcdcecb9211790a9cfc6002e12d10c4'
  },
  {
    id: 12,
    title: 'Banner Sign',
    client: 'Refuge of Grace- Vineland, NJ',
    category: 'Print',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/dc768789-20b8-4e4b-a22b-a561bea48aa4_SIGNS-6.svg?v=28b87f9343c3a71caaf6900a5fc20dcf'
  },
  {
    id: 13,
    title: 'Banner Sign',
    client: 'BIG WB- BALTIMORE, MD',
    category: 'Branding',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/0ee423ba-3aab-4792-9175-8d2846364a45_SIGNS-5.svg?v=8d34d21d549eae324606975771b8a15a'
  },
  {
    id: 14,
    title: 'Banner Sign',
    client: 'JOY FEST- SAN DEIGO, CA',
    category: 'Signage',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/127b1fdb-9332-4f53-b62c-660038535d4d_SIGNS-4.svg?v=890d9b65f41b847b7a31c6ed67d2f51f'
  },
  {
    id: 15,
    title: 'WALL ART',
    client: '2ND CALVARY- CHICAGO, IL',
    category: 'Signage',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://readdy.ai/api/search-image?query=youth ministry banner design vibrant bold colors energetic typography modern church youth department signage inspirational messaging colorful background&width=1200&height=800&seq=portfolio21&orientation=landscape'
  },
  {
    id: 16,
    title: 'CONCESSION SIGN',
    client: 'HICKORY HEAVEN SMOOTHIE- CHESAPEAKE, VA',
    category: 'Signage',
    description: '',
    challenge: '',
    solution: '',
    results: '',
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/9157f291-3486-466a-a9c3-f80434434202_WAYCROSS-SIGNS-2X6.svg?v=6cba88dbf2a5c5db4db0fab5be8a1f42'
  }
];

export default function PortfolioPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFlashing, setIsFlashing] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPaused] = useState(false);
  const nextSlideRef = useRef<() => void>(() => {});

  const filteredProjects = projects;

  const currentProject = filteredProjects[currentIndex];

  const goToSlide = useCallback((index: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIsFlashing(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setTimeout(() => {
        setIsFlashing(false);
        setIsAnimating(false);
      }, 180);
    }, 180);
  }, [isAnimating]);

  const nextSlide = useCallback(() => {
    const next = (currentIndex + 1) % filteredProjects.length;
    goToSlide(next);
  }, [currentIndex, filteredProjects.length, goToSlide]);

  const prevSlide = useCallback(() => {
    const prev = (currentIndex - 1 + filteredProjects.length) % filteredProjects.length;
    goToSlide(prev);
  }, [currentIndex, filteredProjects.length, goToSlide]);

  // Keep ref current so auto-rotate always calls latest version
  useEffect(() => {
    nextSlideRef.current = nextSlide;
  }, [nextSlide]);

  // Auto-rotate
  useEffect(() => {
    if (lightboxOpen || isHovered || isPaused) return;
    const interval = setInterval(() => {
      nextSlideRef.current();
    }, 4000);
    return () => clearInterval(interval);
  }, [lightboxOpen, isHovered, isPaused]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (lightboxOpen) {
        if (e.key === 'Escape') setLightboxOpen(false);
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      } else {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide, lightboxOpen]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <span className="text-[#06B6D4] text-sm font-semibold uppercase tracking-wider">
              Our PROJECT GALLERY
            </span>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mt-4 mb-6 leading-tight">
              Projects That Drive <span className="italic text-[#06B6D4]">Real</span> Results
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Browse some of our featured projects for this week through our interactive gallery.
            </p>
          </div>
        </div>
      </section>

      {/* Slideshow Gallery */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Main Slideshow */}
          <div
            className="relative bg-gray-100 rounded-3xl overflow-hidden shadow-2xl"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Main Image Container — click to enlarge */}
            <div
              className="relative aspect-[16/9] lg:aspect-[21/9] cursor-zoom-in"
              onClick={() => setLightboxOpen(true)}
            >
              {filteredProjects.map((project, index) => (
                <div
                  key={project.id}
                  className={`absolute inset-0 transition-opacity duration-300 ${
                    index === currentIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                </div>
              ))}

              {/* Flash overlay */}
              <div
                className={`absolute inset-0 bg-white z-20 pointer-events-none transition-opacity duration-150 ${
                  isFlashing ? 'opacity-60' : 'opacity-0'
                }`}
              />

              {/* Expand hint */}
              <div className="absolute top-5 left-5 flex items-center gap-2 pointer-events-none">
                <div className="flex flex-col items-center gap-1">
                  <span className="text-white text-[10px] font-semibold uppercase tracking-widest bg-black/40 backdrop-blur-sm rounded-full px-2.5 py-0.5">
                    Click Image to Enlarge
                  </span>
                  <div className="w-9 h-9 flex items-center justify-center bg-black/40 backdrop-blur-sm rounded-full">
                    <i className="ri-fullscreen-line text-white text-lg"></i>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block animate-pulse"></span>
                  <span className="text-white text-xs font-medium">Auto-Playing</span>
                </div>
              </div>

              {/* Project Info Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12 z-10" onClick={(e) => e.stopPropagation()}>
                <div className="max-w-3xl">
                  <span className="inline-block px-4 py-1.5 bg-[#06B6D4] text-white text-sm font-semibold rounded-full mb-4">
                    {currentProject?.category}
                  </span>
                  <h2 className="text-3xl lg:text-5xl font-bold text-white mb-3">
                    {currentProject?.title}
                  </h2>
                  <p className="text-lg text-white/80">
                    {currentProject?.client}
                  </p>
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={(e) => { e.stopPropagation(); prevSlide(); }}
                className="absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 w-12 h-12 lg:w-14 lg:h-14 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all duration-200 cursor-pointer group z-10"
                aria-label="Previous project"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-900 group-hover:-translate-x-0.5 transition-transform"></i>
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); nextSlide(); }}
                className="absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 w-12 h-12 lg:w-14 lg:h-14 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all duration-200 cursor-pointer group z-10"
                aria-label="Next project"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-900 group-hover:translate-x-0.5 transition-transform"></i>
              </button>

              {/* Slide Counter */}
              <div className="absolute top-6 right-6 bg-black/50 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium z-10">
                {currentIndex + 1} / {filteredProjects.length}
              </div>
            </div>
          </div>

          {/* Thumbnail Navigation */}
          <div className="mt-8">
            <div className="flex items-center justify-center space-x-3 overflow-x-auto pb-4">
              {filteredProjects.map((project, index) => (
                <button
                  key={project.id}
                  onClick={() => goToSlide(index)}
                  className={`relative flex-shrink-0 w-24 h-16 lg:w-32 lg:h-20 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${
                    index === currentIndex
                      ? 'ring-2 ring-[#06B6D4] ring-offset-2 scale-105'
                      : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Progress Indicators */}
          <div className="flex items-center justify-center space-x-2 mt-6">
            {filteredProjects.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? 'w-8 bg-[#06B6D4]'
                    : 'w-1.5 bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && currentProject && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center animate-[fadeIn_0.2s_ease]"
          style={{ animation: 'fadeIn 0.2s ease' }}
          onClick={() => setLightboxOpen(false)}
        >
          <style>{`
            @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes zoomIn { from { transform: scale(0.92); opacity: 0; } to { transform: scale(1); opacity: 1; } }
          `}</style>

          {/* Close button */}
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-5 right-5 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>

          {/* Prev arrow */}
          <button
            onClick={(e) => { e.stopPropagation(); prevSlide(); }}
            className="absolute left-4 lg:left-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-s-line text-white text-2xl"></i>
          </button>

          {/* Image */}
          <div
            className="max-w-6xl w-full mx-20 flex flex-col items-center"
            style={{ animation: 'zoomIn 0.25s ease' }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              key={currentProject.id}
              src={currentProject.image}
              alt={currentProject.title}
              className="max-h-[80vh] w-auto max-w-full rounded-xl object-contain"
              style={{ animation: 'zoomIn 0.25s ease' }}
            />
            <div className="mt-5 text-center">
              <p className="text-white text-xl font-semibold">{currentProject.title}</p>
              <p className="text-white/60 text-sm mt-1">{currentProject.client}</p>
            </div>
          </div>

          {/* Next arrow */}
          <button
            onClick={(e) => { e.stopPropagation(); nextSlide(); }}
            className="absolute right-4 lg:right-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Next"
          >
            <i className="ri-arrow-right-s-line text-white text-2xl"></i>
          </button>

          {/* Counter */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-white/10 text-white px-4 py-1.5 rounded-full text-sm">
            {currentIndex + 1} / {filteredProjects.length}
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Ready to Create Your Success Story?
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Let&apos;s work together to bring your vision to life.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            Get Started Today
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}